import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePatch } from '../../../../utils/AxiosUtil';
import * as enums from '../../../../utils/EnumMapping';
import ErrorAwareNumberField from '../../../common/inputfields/ErrorAwareNumberField';
import ErrorAwareSelectField from '../../../common/inputfields/ErrorAwareSelectField';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';

class ModifyTaxType extends Component {

    fields = ["publicId", "name", "paymentDay", "taxPaymentType"];

    state = {
        publicId: this.props.row.publicId ? this.props.row.publicId : '',
        name: this.props.row.name,
        paymentDay: this.props.row.paymentDay ? this.props.row.paymentDay : '',
        taxPaymentType: enums.taxTypes.find(p => p.value === this.props.row.taxPaymentType),
        errors: new Map(),
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/taxType';
        const requestObject = {
            "privateId": this.props.row.privateId,
            "publicId": this.state.publicId,
            "name": this.state.name,
            "paymentDay": this.state.paymentDay,
            "taxPaymentType": this.state.taxPaymentType.value,
        };
        handlePatch(path, requestObject, this);
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="publicId"
                            label="Adónem sorszáma"
                            errors={this.state.errors}
                            value={this.state.publicId}
                            prevValue={this.props.row.publicId}
                            onChange={e => handleChangeEvent(e, this)}
                            modify={true}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            required
                            name="name"
                            label="Adónem megnevezése"
                            errors={this.state.errors}
                            value={this.state.name}
                            prevValue={this.props.row.name}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareNumberField
                            name="paymentDay"
                            label="Fizetési nap"
                            errors={this.state.errors}
                            value={this.state.paymentDay}
                            prevValue={this.props.row.paymentDay}
                            modify={true}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareSelectField
                            labelId="tax-type-label"
                            id="tax-type"
                            name="taxPaymentType"
                            label="Típus"
                            errors={this.state.errors}
                            value={this.state.taxPaymentType}
                            prevValue={enums.getObjectByValue(enums.taxTypes, this.props.row.taxPaymentType)}
                            onChange={e => handleChangeEvent(e, this)}
                            options={enums.taxTypes}
                        />
                    </div>
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Módosítás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(ModifyTaxType);
